/**
 * @generated SignedSource<<013d475205ebf25974cf3cdece05c4ed>>
 * @relayHash 09faeadd53aea9133e76ca4253cdec39
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 09faeadd53aea9133e76ca4253cdec39

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type RepositoryMilestoneEditPageQuery$variables = {
  name: string;
  number: number;
  owner: string;
};
export type RepositoryMilestoneEditPageQuery$data = {
  readonly repository: Result<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"RepositoryMilestoneEditPageContentInternal">;
  } | null | undefined, unknown>;
};
export type RepositoryMilestoneEditPageQuery = {
  response: RepositoryMilestoneEditPageQuery$data;
  variables: RepositoryMilestoneEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "number"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v3 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "number",
    "variableName": "number"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RepositoryMilestoneEditPageQuery",
    "selections": [
      {
        "kind": "CatchField",
        "field": {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "Repository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v4/*: any*/),
              "action": "THROW"
            },
            {
              "args": (v5/*: any*/),
              "kind": "FragmentSpread",
              "name": "RepositoryMilestoneEditPageContentInternal"
            }
          ],
          "storageKey": null
        },
        "to": "RESULT"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "RepositoryMilestoneEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameWithOwner",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerCanPush",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "Milestone",
            "kind": "LinkedField",
            "name": "milestone",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "number",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dueOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "closed",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "09faeadd53aea9133e76ca4253cdec39",
    "metadata": {},
    "name": "RepositoryMilestoneEditPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7285acd66561ec5991fcd22482d8c959";

export default node;
